import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import NearMeIcon from '@mui/icons-material/NearMe';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import StoreIcon from '@mui/icons-material/Store';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import LeafletMap from './LeafletMap';
import ModalDeliveryOrder from './ModalDeliveryOrder';
import './style/PlacingAnOrder.css';
import './style/CartPickup.css';
import './style/DeliveryOrder.css';
import axios from 'axios';

const DeliveryOrder = () => {
    const [mode, setMode] = useState('delivery');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [contracts, setContracts] = useState([]);
    const [selectedOption, setSelectedOption] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchContracts = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}v1/contracts`, {
                    headers: {
                        'x-api-key': '12345xxa'
                    }
                });
                setContracts(response.data);
            } catch (error) {
                console.error('Error fetching contracts:', error);
            }
        };

        fetchContracts();
    }, []);

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handlePaymentSuccess = () => {
        handleCloseModal();
        navigate('/HistoryOfOrders', { state: { message: 'Оплата прошла' } });
    };

    const handlePaymentFailure = () => {
        handleCloseModal();
        alert('Оплата не прошла');
    };

    const handleSelect = (option) => {
        setSelectedOption(option);
        setInputValue(option);
        setIsOpen(false);
    };

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
        setIsOpen(true);
    };

    const filteredOptions = contracts.filter(contract =>
        contract.contract_number.toLowerCase().includes(inputValue.toLowerCase())
    ).map(contract => contract.contract_number);

    const PlacingAnOrder = () => {
        const [selected, setSelected] = useState('Сегодня');
        const [selectedSlot, setSelectedSlot] = useState(null);
        const slots = [
            { time: '10:00-12:00', price: '' },
            { time: '12:00-14:00', price: '' },
            { time: '14:00-16:00', price: '' },
            { time: '16:00-18:00', price: '' },
            { time: '18:00-20:00', price: '' },
            { time: '20:00-22:00', price: '' },
        ];

        return (
            <div className="placinganorder-container">
                <div className="placinganorder-content">
                    <div className="placinganoreder-header">
                    </div>
                    <div className="placinganorder-basic-content">
                        <div className="placinganorder-basic-content-left">
                            <div className="placinganorder-delivery-address">
                                <div className="placinganorder-delivery-address-header">
                                    <div className="placinganorder-delivery-address-header-1">
                                        <h2 className="delivery-address-zagolovok">Адрес доставки</h2>
                                    </div>
                                    <div className="placinganorder-delivery-address-header-2">
                                        <button className="delivery-address-header-button">
                                            <NearMeIcon className="delivery-address-header-icon" />
                                            <span className="delivery-address-header-button-text">Мои адреса</span>
                                        </button>
                                    </div>
                                </div>
                                <div className="placinganorder-delivery-address-content-1">
                                    <div className="placinganorder-delivery-address-content-1-1">
                                        <div className="input-container">
                                            <input
                                                placeholder=" "
                                                className="input-field input-field-placinganorder-delivery-address-input-1-1"
                                                type="text"
                                                id="city"
                                            />
                                            <label htmlFor="city" className="floating-label">Город</label>
                                        </div>
                                        <div className="input-container">
                                            <input
                                                placeholder=" "
                                                className="input-field input-field-placinganorder-delivery-address-input-2-1"
                                                type="text"
                                                id="street"
                                            />
                                            <label htmlFor="street" className="floating-label">Улица</label>
                                        </div>
                                    </div>
                                    <div className="placinganorder-delivery-address-content-1-2">
                                        <div className="input-container">
                                            <input
                                                placeholder=" "
                                                className="input-field input-field-placinganorder-delivery-address-input-3-1"
                                                type="text"
                                                id="house"
                                            />
                                            <label htmlFor="house" className="floating-label">Дом</label>
                                        </div>
                                        <div className="input-container">
                                            <input
                                                placeholder=" "
                                                className="input-field input-field-placinganorder-delivery-address-input-4-1"
                                                type="text"
                                                id="entrance"
                                            />
                                            <label htmlFor="entrance" className="floating-label">Подъезд</label>
                                        </div>
                                        <div className="input-container">
                                            <input
                                                placeholder=" "
                                                className="input-field input-field-placinganorder-delivery-address-input-5-1"
                                                type="text"
                                                id="floor"
                                            />
                                            <label htmlFor="floor" className="floating-label">Этаж</label>
                                        </div>
                                    </div>
                                    <div className="placinganorder-delivery-address-content-1-3">
                                        <div className="input-container">
                                            <input
                                                placeholder=" "
                                                className="input-field input-field-placinganorder-delivery-address-input-6-1"
                                                type="text"
                                                id="apartment"
                                            />
                                            <label htmlFor="apartment" className="floating-label">Квартира</label>
                                        </div>
                                        <div className="input-container">
                                            <input
                                                placeholder=" "
                                                className="input-field input-field-placinganorder-delivery-address-input-7-1"
                                                type="text"
                                                id="intercom"
                                            />
                                            <label htmlFor="intercom" className="floating-label">Домофон</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="placinganorder-delivery-address-content-2">
                                    <div className="placinganorder-contact">
                                        <h2 className="placinganorder-contact-zagolovok">Контакты</h2>
                                    </div>
                                    <div className="placinganorder-contact-input-container">
                                        <div className="input-container">
                                            <input
                                                placeholder=" "
                                                className="input-field input-field-placinganorder-contact-input-1"
                                                type="text"
                                                id="phone"
                                            />
                                            <label htmlFor="phone" className="floating-label">Номер телефона</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="placinganorder-delivery-select-container-combobox">
                                    <label htmlFor="my-select" className="placinganorder-delivery-label-combobox">Договора</label>
                                    <div className="placinganorder-delivery-select-box-combobox">
                                        <input
                                            type="text"
                                            id="my-select"
                                            className="input-field input-field-placinganorder-delivery-input-combobox"
                                            value={inputValue}
                                            placeholder="Договор"
                                            onChange={handleInputChange}
                                        />
                                        <div
                                            className="placinganorder-delivery-select-arrow-combobox"
                                            onClick={() => setIsOpen(!isOpen)}
                                        >
                                            &#9660;
                                        </div>
                                    </div>
                                    {isOpen && (
                                        <ul className="placinganorder-delivery-select-options-combobox">
                                            {filteredOptions.map((option) => (
                                                <li key={option} onClick={() => handleSelect(option)} className="placinganorder-delivery-combobox-1">
                                                    {option}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            </div>
                            <div className="placinganorder-coment-container">
                                <div className="placinganorder-coment-zagolovok">
                                    <h2 className="placinganorder-coment-zagolovok-1">Комментарий</h2>
                                </div>
                                <div className="input-container">
                                    <input
                                        placeholder=" "
                                        className="input-field input-field-placinganorder-coment-input-1"
                                        type="text"
                                        id="comment"
                                    />
                                    <label htmlFor="comment" className="floating-label">Наш курьер его обязательно увидит</label>
                                </div>
                            </div>
                        </div>
                        <div className="placinganorder-basic-content-right">
                            <div className="placinganorder-basic-content-right-1">
                                <div className="placinganorder-right-content-zagolovok">
                                    <h2 className="placinganorder-right-content-zagolovok-1">Когда доставить</h2>
                                </div>
                                <div className="placinganorder-right-content-day">
                                    <div className="placinganorder-right-content-day-1">
                                        <button
                                            className={`placinganorder-right-content-day-1-1 ${selected === 'Сегодня' ? 'selected' : ''}`}
                                            onClick={() => setSelected('Сегодня')}
                                        >
                                            Сегодня
                                        </button>
                                    </div>
                                    <div className="placinganorder-right-content-day-2">
                                        <button
                                            className={`placinganorder-right-content-day-2-1 ${selected === 'Завтра' ? 'selected' : ''}`}
                                            onClick={() => setSelected('Завтра')}
                                        >
                                            Завтра
                                        </button>
                                    </div>
                                    <div className="placinganorder-right-content-day-3">
                                        <button
                                            className={`placinganorder-right-content-day-3-1 ${selected === 'Послезавтра' ? 'selected' : ''}`}
                                            onClick={() => setSelected('Послезавтра')}
                                        >
                                            Послезавтра
                                        </button>
                                    </div>
                                </div>
                                <div className="placinganorder-right-content-time">
                                    <div className="placinganorder-right-content-time-1">
                                        <div className="placinganorder-time-block-1">
                                            {slots.map((slot, index) => (
                                                <div
                                                    key={index}
                                                    className={`placinganorder-time-slot ${selectedSlot === index ? 'selected' : ''}`}
                                                    onClick={() => setSelectedSlot(index)}
                                                >
                                                    <div className="placinganorder-time-content">{slot.time}</div>
                                                    <div className="placinganorder-price-content">{slot.price}</div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className="placinganorder-total-price-block">
                                    <span className="placinganoreder-total-price">Итоговая сумма:</span>
                                </div>
                                <div className="placinganorder-right-knopka-block">
                                    <button className="placinganorder-right-knopka" onClick={handleOpenModal}>
                                        <span className="placinganorder-right-knopka-text">Оплатить</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const CartPickup = () => {
        const addresses = [
            { id: 1, street: "пр-т Туран, д.121", time: "8:00-20:30" },
            { id: 2, street: "ул. Шалкыма, д.31", time: "8:00-20:30" },
            { id: 3, street: "пер. Сарайшык, д.21", time: "8:00-21:00" },
            { id: 4, street: "пр-т Мангілик Ел., д.45", time: "8:00-20:30" },
            { id: 5, street: "ул. Шалкыма, д.211", time: "8:00-21:30" },
            { id: 6, street: "ул. Пушкина, д.120", time: "8:00-20:00" },
            { id: 7, street: "ул. Президента, д.11", time: "9:00-20:00" },
            { id: 8, street: "ул. Гагарина, д.21", time: "6:00-20:30" },
            { id: 9, street: "ул. Сыганак, д.65", time: "1:00-20:30" },
        ];
        const [selectedAddress, setSelectedAddress] = useState(addresses[0]);

        return (
            <div className="cart-pickup-container">
                <div className="cart-pickup-content-container">
                    <div className="cart-pickup-top-content">
                        <div className="cart-pickup-top-header-content">
                            <div className="cart-pickup-top-header-content-1">
                                <div className="cart-pickup-top-header-text-block-1">
                                    <span className="cart-pickup-top-header-text-1">Укажите свой адрес</span>
                                </div>
                                <div className="cart-pickup-top-header-text-block-1">
                                    <span className="cart-pickup-top-header-text-2">Мы покажем ближайшие к Вам магазины</span>
                                </div>
                            </div>
                            <div className="cart-pickup-top-header-content-2">
                                <button className="cart-pickup-top-header-text-knopka">
                                    <NearMeIcon className="cart-pickup-top-header-text-knopka-icon" />
                                    <span className="cart-pickup-top-header-text-knopka-1">Определить на карте</span>
                                </button>
                            </div>
                        </div>
                        <div className="cart-pickup-input-header-content">
                            <div className="cart-pickup-input-1">
                                <input placeholder="Город" className="input-field input-field-cart-pickup-input-1-1" type="text" />
                            </div>
                            <div className="cart-pickup-input-2">
                                <input placeholder="Улица" className="input-field input-field-cart-pickup-input-2-2" type="text" />
                            </div>
                            <div className="cart-pickup-input-3">
                                <input placeholder="Дом" className="input-field input-field-cart-pickup-input-3-3" type="text" />
                            </div>
                        </div>
                    </div>
                    <div className="cart-pickup-zagolovok-2">
                        <h2 className="cart-pickup-zagolovok-2-1">Ближайшие магазины</h2>
                    </div>
                    <div className="cart-pickup-basic-content">
                        <div className="cart-pickup-basic-map">
                            <LeafletMap />
                        </div>
                        <div className="cart-pickup-basic-address">
                            <div className="cart-pickup-address-list-container">
                                <div className="cart-pickup-address-list">
                                    {addresses.map(address => (
                                        <div
                                            key={address.id}
                                            className={`cart-pickup-address-item ${selectedAddress.id === address.id ? 'selected' : ''}`}
                                            onClick={() => setSelectedAddress(address)}
                                        >
                                            <p className="cart-pickup-address-street">{address.street}</p>
                                            <p className="cart-pickup-address-time">{address.time}</p>
                                        </div>
                                    ))}
                                </div>
                                <div className="cart-pickup-selected-address-block">
                                    <p className="cart-pickup-selected-address-street">{selectedAddress.street}</p>
                                    <p className="cart-pickup-selected-address-time">С {selectedAddress.time}</p>
                                    <p className="cart-pickup-selected-address-info">Самовывоз бесплатно</p>
                                    <button className="cart-pickup-selected-address-button">
                                        <LocationOnIcon className="cart-pickup-address-icon" />
                                        <span className="cart-pickup-address-text-knopka">Заберу отсюда</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="delivery-order-container">
            <div className="delivery-order-header">
                <h1 className="delivery-order-title">Оформление заказа</h1>
                <div className="delivery-order-switch">
                    <button
                        className={`delivery-order-button ${mode === 'delivery' ? 'selected' : ''}`}
                        onClick={() => setMode('delivery')}
                    >
                        <LocalShippingIcon />
                        {mode === 'delivery' && <span>Доставка</span>}
                    </button>
                    <button
                        className={`delivery-order-button ${mode === 'pickup' ? 'selected' : ''}`}
                        onClick={() => setMode('pickup')}
                    >
                        <StoreIcon />
                        {mode === 'pickup' && <span>Самовывоз</span>}
                    </button>
                </div>
            </div>
            <div className="delivery-order-content">
                {mode === 'delivery' ? <PlacingAnOrder /> : <CartPickup />}
            </div>
            <ModalDeliveryOrder
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onPaymentSuccess={handlePaymentSuccess}
                onPaymentFailure={handlePaymentFailure}
            />
        </div>
    );
};

export default DeliveryOrder;
